module.exports = __webpack_public_path__ + "static/oraclelogo-353f4b7720c191535f757804d22327fd.png";